import { createSelector } from 'reselect';

const isSuperAdmin = auth => !!auth.isSuperAdmin;
export default createSelector(state => state.auth, isSuperAdmin);
